class ComponentFlavorSelector extends Theme.Component {
  constructor() {
    super();

    this.defineElements({
      grid: ".product-flavor-grid"
    });

    this.defineElementCollections({
      tiles: ".product-flavor-tile"
    });
  }

  connectedCallback() {
    super.connectedCallback();

    this.restoreOrder();

    this.addEventListener("click", (event) => {
      const tile = event.target.closest(".product-flavor-tile");

      if (!tile) {
        return;
      }

      this.saveOrder(tile.dataset.group);
    });
  }

  get storageKey() {
    return `flavor-selector-${this.dataset.line}`;
  }

  readOrder() {
    try {
      return JSON.parse(sessionStorage.getItem(this.storageKey));
    } catch (error) {
      return null;
    }
  }

  saveOrder(target) {
    const order = Array.from(this.elements.grid.children).map((tile) => tile.dataset.group);

    try {
      sessionStorage.setItem(this.storageKey, JSON.stringify({ target, order, from: window.location.pathname }));
    } catch (error) {
      return;
    }
  }

  referrerPath() {
    try {
      return new URL(document.referrer).pathname;
    } catch (error) {
      return null;
    }
  }

  restoreOrder() {
    const stored = this.readOrder();

    if (!stored || stored.target != this.dataset.current || stored.from != this.referrerPath()) {
      return;
    }

    const tiles = new Map(this.elements.tiles.map((tile) => [tile.dataset.group, tile]));

    if (stored.order.length != tiles.size || !stored.order.every((group) => tiles.has(group))) {
      return;
    }

    stored.order.forEach((group) => {
      this.elements.grid.append(tiles.get(group));
    });
  }
}

customElements.define("component-flavor-selector", ComponentFlavorSelector);
